"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _PulseNotificationMessage = _interopRequireDefault(require("./PulseNotificationMessage"));

var _adobeIntlReact = _interopRequireDefault(require("@adobe/adobe-intl-react"));

var localizationStrings = _interopRequireWildcard(require("./__localization__/PulseNotificationMessageWrapper"));

/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
var PulseNotificationMessageWrapper = function PulseNotificationMessageWrapper(props) {
  var locale = props.locale;
  return _react.default.createElement(_adobeIntlReact.default, {
    locale: locale,
    localeData: localizationStrings
  }, _react.default.createElement(_PulseNotificationMessage.default, (0, _extends2.default)({}, props, {
    showError: false
  })));
};
/**
 * TODO: Need to check how it uses localizationStrings
 * TODO: defaultProps
 */


PulseNotificationMessageWrapper.defaultProps = {
  locale: 'en-US',
  localizationStrings: {
    markAsUnread: 'Mark as unread',
    markAsRead: 'Mark as read',
    High: 'High',
    Approve: 'Approve',
    Reject: 'Reject',
    DismissReminder: 'Dismiss reminder',
    DismissAlert: 'Dismiss',
    Snooze: 'Remind me',
    DeleteReminder: 'Delete reminder',
    EditReminder: 'Edit reminder',
    RemindMeTomorrow: 'Remind me tomorrow',
    RemindMe60Min: 'Remind me in an hour',
    RemindMe15Min: 'Remind me in 15 minutes',
    RemindMe5Min: 'Remind me in 5 minutes'
  }
};
var _default = PulseNotificationMessageWrapper;
exports.default = _default;